import { memo } from "react";
import { TeamListHeader } from "../TeamManagement/TeamListHeader";
import { TeamListRow } from "../TeamManagement/TeamListRow";
import type {
  UIHashKey,
  SelectionState,
  HashKeyActions,
} from "@/features/auth/types/hashKeys.types";

interface HashKeysListProps {
  hashKeys: UIHashKey[];
  selectionState: SelectionState;
  actions: HashKeyActions;
  isDeleting?: boolean;
}

/**
 * Hash keys list component that displays the table of hash keys
 */
const HashKeysList = memo<HashKeysListProps>(
  ({ hashKeys, selectionState, actions, isDeleting }) => (
    <div className="overflow-hidden rounded-lg">
      <TeamListHeader
        checked={selectionState.allSelected}
        indeterminate={selectionState.someSelected}
        onCheckedChange={actions.onSelectAll}
      />
      <div className="flex flex-col gap-3">
        {hashKeys
          .sort(
            (a: UIHashKey, b: UIHashKey) => Number(b.active) - Number(a.active),
          )
          .map((hashKey) => (
            <TeamListRow
              key={hashKey.id}
              member={hashKey}
              isSelected={selectionState.selectedKeys.has(hashKey.id)}
              onSelect={() => actions.onSelect(hashKey.id)}
              onEdit={actions.onEdit}
              onDelete={actions.onDelete}
              onCopyHash={actions.onCopyHash}
              isDeleting={isDeleting}
            />
          ))}
      </div>
    </div>
  ),
);

HashKeysList.displayName = "HashKeysList";

export default HashKeysList;
